import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SettingsOverviewDataProvider } from '@services/settings/settings-overview/settings-overview.data.service';
import { SettingsOverview } from '@models/brands.model';

@Component({
	selector: 'settings-overview',
	template: require('./settings-overview.component.html'),
	styles: [require('./settings-overview.component.scss')],
	encapsulation: ViewEncapsulation.None
})
export class SettingsOverviewComponent implements OnInit {
	settingsLists: SettingsOverview;

	constructor(private settingsOverviewService: SettingsOverviewDataProvider) {}

	ngOnInit(): void {
		this.getSettingsOverviewList();
	}

	getSettingsOverviewList() {
		this.settingsOverviewService
			.settingsOverview()
			.filter(data => data !== null)
			.subscribe((data: SettingsOverview) => (this.settingsLists = data));
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/settings-overview/settings-overview.component.ts